import React from 'react'
import { useNavigate } from "react-router-dom";
import { useIntl } from 'react-intl';
import  "./SuccessNumberChange.css";

function ChildSuccessNumberChange() {
    const navigate = useNavigate();
    const intl = useIntl();
    function back(){
        navigate("/");
    }
    return (
        <div className={('success_wrapper responsive_wrapper')}>
            <p className={('success')}>Your Password Is Successfully Changed.</p>
            <div></div>
            <button className={('success_button')} onClick={back}>back</button>
        </div>
      )
}
export default ChildSuccessNumberChange;